import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import { attempt, defaultTo } from 'lodash-es';
import useChart from '../UseChart';
import useHighcharts from '../UseHighcharts';
import useModifiedProps from '../UseModifiedProps';
var Tooltip = memo(function (props) {
  // eslint-disable-next-line no-unused-vars
  var _props$children = props.children,
      children = _props$children === void 0 ? null : _props$children,
      restProps = _objectWithoutProperties(props, ["children"]);

  var chart = useChart();
  var Highcharts = useHighcharts();
  restProps.enabled = defaultTo(props.enabled, true);
  useEffect(function () {
    var chartObj = chart.object;
    chartObj.tooltip = new Highcharts.Tooltip(chartObj, _objectSpread({}, Highcharts.defaultOptions && Highcharts.defaultOptions.tooltip, {}, restProps));
    return function () {
      attempt(updateTooltip, chart, {
        enabled: false
      });
    };
  }, []);
  var modifiedProps = useModifiedProps(restProps);
  useEffect(function () {
    if (modifiedProps !== false) {
      updateTooltip(chart, modifiedProps);
    }
  });
  return null;
});

var updateTooltip = function updateTooltip(chart, config) {
  var tooltip = chart.object.tooltip;
  tooltip.update(config);
};

Tooltip.displayName = 'Tooltip';
Tooltip.propTypes = {
  enabled: PropTypes.bool
};
export default Tooltip;